module.exports = __webpack_public_path__ + "static/media/galdisa_blog_blog_header.7373509e.png";